/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserTenantsResponseDto } from './UserTenantsResponseDto';
export type UserResponseDto = {
  /**
   * User id from Cognito.
   */
  cognitoUserId: string;
  /**
   * User email address
   */
  email: string;
  /**
   * User first name
   */
  name: string;
  /**
   * User surname
   */
  surname: string;
  /**
   * User locale
   */
  locale: UserResponseDto.locale;
  /**
   * Current status of the user
   */
  status: UserResponseDto.status;
  /**
   * List of tenants this user belongs to
   */
  tenants: Array<UserTenantsResponseDto>;
  /**
   * Indicates whether tenant requires MFA for this user
   */
  mfaRequired: boolean;
  /**
   * Indicates whether MFA is enabled for this user
   */
  mfaEnabled: boolean;
  /**
   * Timestamp when the user was activated
   */
  activatedAt?: string;
  /**
   * Timestamp when the user was deactivated
   */
  deactivatedAt?: string;
};
export namespace UserResponseDto {
  /**
   * User locale
   */
  export enum locale {
    EN = 'EN',
    LV = 'LV',
    NO = 'NO',
    FI = 'FI',
  }
  /**
   * Current status of the user
   */
  export enum status {
    ACTIVE = 'ACTIVE',
    ACTIVATION_IN_PROGRESS = 'ACTIVATION_IN_PROGRESS',
    PENDING = 'PENDING',
    PENDING_IN_PROGRESS = 'PENDING_IN_PROGRESS',
    SUSPENDED = 'SUSPENDED',
    SUSPEND_IN_PROGRESS = 'SUSPEND_IN_PROGRESS',
    DEACTIVATED = 'DEACTIVATED',
    DEACTIVATE_IN_PROGRESS = 'DEACTIVATE_IN_PROGRESS',
    RESET = 'RESET',
    RESET_IN_PROGRESS = 'RESET_IN_PROGRESS',
  }
}

